// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nachträge. Every selector is scoped to .change-orders-page; dialogs get it as rootClassName. */

.change-orders-page .co-full {
  width: 100%;
}

.change-orders-page .co-num {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.change-orders-page .co-negative {
  color: var(--ds-danger);
}

.change-orders-page .co-small {
  font-size: 13px;
  color: var(--ds-text-muted);
}

.change-orders-page .co-empty-text {
  max-width: 520px;
  margin-inline: auto;
}

.change-orders-page .co-offer-filter {
  width: 100%;
  max-width: 420px;
}

/* ---- Header ---- */
.change-orders-page .co-header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
}

.change-orders-page .co-header-title {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex: 1 1 0;
  min-width: 0;
  flex-wrap: wrap;
}

.change-orders-page .co-header-title h4 {
  margin: 0;
  overflow-wrap: anywhere;
}

.change-orders-page .co-parent {
  margin: var(--ds-space-2) 0 0;
}

/* ---- Positions ---- */
.change-orders-page .co-line {
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
  background: var(--ds-surface);
}

.change-orders-page .co-line-head {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-2);
}

.change-orders-page .co-line-figures {
  flex: 1 1 auto;
  text-align: end;
}

.change-orders-page .co-line-total {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.change-orders-page .co-field {
  display: block;
}

.change-orders-page .co-field-label {
  display: block;
  font-size: 12px;
  color: var(--ds-text-muted);
  margin-bottom: 2px;
}

.change-orders-page .co-hint {
  display: block;
  margin-top: var(--ds-space-2);
  font-size: 12px;
}

.change-orders-page .co-totals {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px var(--ds-space-4);
  max-width: 360px;
  margin: var(--ds-space-3) 0 0 auto;
}

.change-orders-page .co-totals dt {
  color: var(--ds-text-muted);
}

.change-orders-page .co-totals dd {
  margin: 0;
  text-align: end;
  font-variant-numeric: tabular-nums;
}

.change-orders-page .co-totals .co-gross {
  font-weight: 600;
  color: var(--ds-heading);
  border-top: 1px solid var(--ds-border);
  padding-top: 4px;
}

/* ---- Photos ---- */
.change-orders-page .co-photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: var(--ds-space-3);
}

.change-orders-page .co-photo-grid figure {
  position: relative;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1);
}

.change-orders-page .co-photo-grid .ant-image,
.change-orders-page .co-photo-grid .ant-image-img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: var(--ds-radius-sm);
}

.change-orders-page .co-photo-grid figcaption {
  font-size: 12px;
  color: var(--ds-text-muted);
}

.change-orders-page .co-photo-remove {
  position: absolute;
  inset-block-start: 4px;
  inset-inline-end: 4px;
  background: var(--ds-surface);
  box-shadow: var(--ds-shadow-sm);
}

/* ---- Overview ---- */
.change-orders-page .co-current-row td {
  background: var(--ds-brand-50);
}

/* ---- Preview ---- */
.change-orders-page .co-preview-title {
  margin: 0 !important;
}

.change-orders-page .co-preview-facts {
  margin: var(--ds-space-3) 0;
}

.change-orders-page .co-preview-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.change-orders-page .co-preview-lines {
  margin: 0;
  padding-inline-start: 22px;
}

.change-orders-page .co-preview-lines li {
  padding: var(--ds-space-2) 0;
  border-bottom: 1px solid var(--ds-border);
}

.change-orders-page .co-line-main {
  display: flex;
  justify-content: space-between;
  gap: var(--ds-space-3);
}

.change-orders-page .co-line-text {
  min-width: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.change-orders-page .co-line-sub {
  font-size: 13px;
  color: var(--ds-text-muted);
}

.change-orders-page .co-decision {
  margin-top: var(--ds-space-3);
  padding: var(--ds-space-2) var(--ds-space-3);
  border-radius: var(--ds-radius-sm);
  border: 1px solid var(--ds-border);
}

.change-orders-page .co-decision img {
  display: block;
  max-height: 72px;
  max-width: 100%;
  margin-top: var(--ds-space-2);
  background: #fff;
}

.change-orders-page .co-decision-approved {
  background: var(--ds-success-bg);
  border-color: var(--ds-success);
}

.change-orders-page .co-decision-rejected {
  background: var(--ds-danger-bg);
  border-color: var(--ds-danger);
}

.change-orders-page .co-decision-ordered {
  background: var(--ds-warning-bg);
  border-color: var(--ds-warning);
}

/* ---- Phones ---- */
.change-orders-page .co-bottom-bar {
  display: none;
}

@media (max-width: 767px) {
  .change-orders-page .co-header:has(.co-hide-phone) {
    flex-wrap: nowrap;
    align-items: flex-start;
  }

  .change-orders-page .co-header-title h4 {
    font-size: 18px;
  }

  .change-orders-page .co-header-actions {
    width: 100%;
  }

  .change-orders-page .co-header-actions.co-hide-phone {
    display: none;
  }

  .change-orders-page .co-bottom-bar {
    display: flex;
    gap: var(--ds-space-2);
    position: sticky;
    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + 8px);
    z-index: 5;
    margin-top: var(--ds-space-3);
    padding: var(--ds-space-2);
    border-radius: var(--ds-radius-lg);
    background: var(--ds-surface);
    box-shadow: var(--ds-shadow-lg);
  }

  .change-orders-page .co-bottom-bar > .ant-btn-primary {
    flex: 1 1 auto;
  }

  .change-orders-page .co-section .ant-card-head-wrapper {
    flex-wrap: wrap;
    gap: var(--ds-space-2);
    padding-block: var(--ds-space-2);
  }

  .change-orders-page .co-section .ant-card-extra {
    margin-inline-start: 0;
  }
}

/* ---- Public approval page ---- */
.change-orders-page.co-public {
  min-height: 100vh;
  background: var(--ds-bg);
  padding: var(--ds-space-4) 16px;
}

.change-orders-page .co-public-inner {
  max-width: 760px;
  margin: 0 auto;
}

.change-orders-page .co-public-company {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-3);
}

.change-orders-page .co-public-company img {
  max-height: 40px;
  max-width: 160px;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/changeOrders/changeOrders.css"],"names":[],"mappings":"AAAA,iGAAiG;;AAEjG;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wBAAwB;AACxB;EACE,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;EAC1B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iEAAiE;IACjE,UAAU;IACV,6BAA6B;IAC7B,0BAA0B;IAC1B,kCAAkC;IAClC,6BAA6B;IAC7B,+BAA+B;EACjC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["/* Nachträge. Every selector is scoped to .change-orders-page; dialogs get it as rootClassName. */\n\n.change-orders-page .co-full {\n  width: 100%;\n}\n\n.change-orders-page .co-num {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.change-orders-page .co-negative {\n  color: var(--ds-danger);\n}\n\n.change-orders-page .co-small {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n.change-orders-page .co-empty-text {\n  max-width: 520px;\n  margin-inline: auto;\n}\n\n.change-orders-page .co-offer-filter {\n  width: 100%;\n  max-width: 420px;\n}\n\n/* ---- Header ---- */\n.change-orders-page .co-header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n}\n\n.change-orders-page .co-header-title {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex: 1 1 0;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.change-orders-page .co-header-title h4 {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n.change-orders-page .co-parent {\n  margin: var(--ds-space-2) 0 0;\n}\n\n/* ---- Positions ---- */\n.change-orders-page .co-line {\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n  background: var(--ds-surface);\n}\n\n.change-orders-page .co-line-head {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-2);\n}\n\n.change-orders-page .co-line-figures {\n  flex: 1 1 auto;\n  text-align: end;\n}\n\n.change-orders-page .co-line-total {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n}\n\n.change-orders-page .co-field {\n  display: block;\n}\n\n.change-orders-page .co-field-label {\n  display: block;\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  margin-bottom: 2px;\n}\n\n.change-orders-page .co-hint {\n  display: block;\n  margin-top: var(--ds-space-2);\n  font-size: 12px;\n}\n\n.change-orders-page .co-totals {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 4px var(--ds-space-4);\n  max-width: 360px;\n  margin: var(--ds-space-3) 0 0 auto;\n}\n\n.change-orders-page .co-totals dt {\n  color: var(--ds-text-muted);\n}\n\n.change-orders-page .co-totals dd {\n  margin: 0;\n  text-align: end;\n  font-variant-numeric: tabular-nums;\n}\n\n.change-orders-page .co-totals .co-gross {\n  font-weight: 600;\n  color: var(--ds-heading);\n  border-top: 1px solid var(--ds-border);\n  padding-top: 4px;\n}\n\n/* ---- Photos ---- */\n.change-orders-page .co-photo-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: var(--ds-space-3);\n}\n\n.change-orders-page .co-photo-grid figure {\n  position: relative;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1);\n}\n\n.change-orders-page .co-photo-grid .ant-image,\n.change-orders-page .co-photo-grid .ant-image-img {\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: var(--ds-radius-sm);\n}\n\n.change-orders-page .co-photo-grid figcaption {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.change-orders-page .co-photo-remove {\n  position: absolute;\n  inset-block-start: 4px;\n  inset-inline-end: 4px;\n  background: var(--ds-surface);\n  box-shadow: var(--ds-shadow-sm);\n}\n\n/* ---- Overview ---- */\n.change-orders-page .co-current-row td {\n  background: var(--ds-brand-50);\n}\n\n/* ---- Preview ---- */\n.change-orders-page .co-preview-title {\n  margin: 0 !important;\n}\n\n.change-orders-page .co-preview-facts {\n  margin: var(--ds-space-3) 0;\n}\n\n.change-orders-page .co-preview-text {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.change-orders-page .co-preview-lines {\n  margin: 0;\n  padding-inline-start: 22px;\n}\n\n.change-orders-page .co-preview-lines li {\n  padding: var(--ds-space-2) 0;\n  border-bottom: 1px solid var(--ds-border);\n}\n\n.change-orders-page .co-line-main {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--ds-space-3);\n}\n\n.change-orders-page .co-line-text {\n  min-width: 0;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.change-orders-page .co-line-sub {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n.change-orders-page .co-decision {\n  margin-top: var(--ds-space-3);\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border-radius: var(--ds-radius-sm);\n  border: 1px solid var(--ds-border);\n}\n\n.change-orders-page .co-decision img {\n  display: block;\n  max-height: 72px;\n  max-width: 100%;\n  margin-top: var(--ds-space-2);\n  background: #fff;\n}\n\n.change-orders-page .co-decision-approved {\n  background: var(--ds-success-bg);\n  border-color: var(--ds-success);\n}\n\n.change-orders-page .co-decision-rejected {\n  background: var(--ds-danger-bg);\n  border-color: var(--ds-danger);\n}\n\n.change-orders-page .co-decision-ordered {\n  background: var(--ds-warning-bg);\n  border-color: var(--ds-warning);\n}\n\n/* ---- Phones ---- */\n.change-orders-page .co-bottom-bar {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .change-orders-page .co-header:has(.co-hide-phone) {\n    flex-wrap: nowrap;\n    align-items: flex-start;\n  }\n\n  .change-orders-page .co-header-title h4 {\n    font-size: 18px;\n  }\n\n  .change-orders-page .co-header-actions {\n    width: 100%;\n  }\n\n  .change-orders-page .co-header-actions.co-hide-phone {\n    display: none;\n  }\n\n  .change-orders-page .co-bottom-bar {\n    display: flex;\n    gap: var(--ds-space-2);\n    position: sticky;\n    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + 8px);\n    z-index: 5;\n    margin-top: var(--ds-space-3);\n    padding: var(--ds-space-2);\n    border-radius: var(--ds-radius-lg);\n    background: var(--ds-surface);\n    box-shadow: var(--ds-shadow-lg);\n  }\n\n  .change-orders-page .co-bottom-bar > .ant-btn-primary {\n    flex: 1 1 auto;\n  }\n\n  .change-orders-page .co-section .ant-card-head-wrapper {\n    flex-wrap: wrap;\n    gap: var(--ds-space-2);\n    padding-block: var(--ds-space-2);\n  }\n\n  .change-orders-page .co-section .ant-card-extra {\n    margin-inline-start: 0;\n  }\n}\n\n/* ---- Public approval page ---- */\n.change-orders-page.co-public {\n  min-height: 100vh;\n  background: var(--ds-bg);\n  padding: var(--ds-space-4) 16px;\n}\n\n.change-orders-page .co-public-inner {\n  max-width: 760px;\n  margin: 0 auto;\n}\n\n.change-orders-page .co-public-company {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-3);\n}\n\n.change-orders-page .co-public-company img {\n  max-height: 40px;\n  max-width: 160px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
